const pathAfterLogin = {
  needsPasswordChange: (ProfileService, getToken) => {
    const token = ProfileService.parseJWT(getToken());
    if (!token) return false;
    const localSuccessChangePassword = localStorage.getItem('SUCCESS_CHANGE_PASSWORD');
    return !!(
      token.changePassword &&
      (!localSuccessChangePassword || parseInt(localSuccessChangePassword, 10) === 0)
    );
  },
  /**
   * Persiste a rota completa (pathname + search) para restauração após login.
   * @param {string} pathToSave - pathname da localização atual
   * @param {string} searchToSave - search (query string) da localização atual
   * @param {boolean} isAuthenticated
   */
  setPath: (pathToSave, isAuthenticated, searchToSave = '') => {
    const notSavePaths = ['/login', '/', '/mfa', '/mfa/choose']
    const shouldSave = notSavePaths.every(path => path !== pathToSave)
    if (!isAuthenticated && shouldSave) {
      const fullPath = searchToSave ? `${pathToSave}${searchToSave}` : pathToSave
      localStorage.setItem('pathAfterLogin', fullPath);
    }
  },
  getPath: (ProfileService, getToken) => {
    const path = localStorage.getItem('pathAfterLogin');
    return pathAfterLogin.needsPasswordChange(ProfileService, getToken)
      ? '/reset'
      : path || '/home';
  },
  getPathWithoutToken: () => {
    return localStorage.getItem('pathAfterLogin') || '';
  },
  removePath: () => {
    localStorage.removeItem('pathAfterLogin');
  }
}

export default pathAfterLogin;